import { useEffect } from 'react';
import "./loader.css";
import { partialRefresh } from '../../helpers/helper';
import { useDispatch } from 'react-redux';


  const Loader = ({ color, circleSize, transform, positionleft , positiontop, Zindex,loaderposition, dispatch, message }) => {

    const dispatchForThisComp = dispatch ? dispatch : useDispatch();

    const loaderStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        top: positiontop ||'50%',
        left: positionleft||'50%',                                                                
        position: loaderposition || 'fixed',
        transform:transform|| 'translate(-50%, -50%)',
        zIndex:Zindex||'0',
    };
    const circleStyle = {
        width: circleSize || '15px',
        height: circleSize || '15px',
        borderRadius: '50%',
        margin: '0 10px',
        backgroundColor: color || '#134157',
        animation: 'circle1 1s ease-in-out infinite',
    };

    useEffect(() => {

      const timer = setTimeout(() => {
      const userInactive = JSON.parse(localStorage.getItem('inactive'));

        if (!userInactive) {
          dispatchForThisComp(partialRefresh());
        }
      }, 5000);

      return () => {
        clearTimeout(timer);
      };
    }, []);

  return (
    <div style={{ ...loaderStyle, flexDirection: 'column' }}>
      {message && (
        <div className="loader3__message">{message}</div>
      )}
      <div className="loader3"style={loaderStyle} >
        <div className="circle1" style={circleStyle}></div>
        <div className="circle1" style={circleStyle}></div>
        <div className="circle1" style={circleStyle}></div>
        <div className="circle1" style={circleStyle}></div>
        <div className="circle1" style={circleStyle}></div>
      </div>
</div>
  )
}

export default Loader;
